import { QueryClient, QueryKey } from "@tanstack/react-query";

export const EMR_LIVE_EVENT_KINDS = [
  "ConnectionsChanged",
  "JobChanged",
  "ExportChanged",
] as const;

export type EMRLiveEventKind = (typeof EMR_LIVE_EVENT_KINDS)[number];

export type EMRLiveEventPayload = {
  hubId: string;
  connectionId?: string;
  jobId?: string;
  exportId?: string;
};

export const queryKeysForEvent = (
  clinicId: string,
  kind: EMRLiveEventKind,
  { hubId, connectionId }: EMRLiveEventPayload
): Array<QueryKey> => {
  switch (kind) {
    case "ConnectionsChanged":
      return [
        ["emr-hubs", clinicId],
        ["emr-hub-connections", clinicId, hubId],
        ["emr-hub-problems", clinicId, hubId],
        ["emr-pac-servers", clinicId, hubId],
      ];
    case "JobChanged":
      return [
        ["emr-jobs", clinicId, hubId],
        ["emr-hub-connections", clinicId, hubId],
        ["emr-pac-servers", clinicId, hubId],
      ];
    case "ExportChanged":
      return [
        ["emr-exports", clinicId, connectionId],
        ["emr-export-counts", clinicId, connectionId],
      ];
  }
};

export const invalidateForEvent = (
  queryClient: QueryClient,
  clinicId: string,
  kind: EMRLiveEventKind,
  payload: EMRLiveEventPayload
) =>
  Promise.all(
    queryKeysForEvent(clinicId, kind, payload).map((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    )
  );

export const invalidateAllForClinic = (
  queryClient: QueryClient,
  clinicId: string
) =>
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) =>
      typeof queryKey[0] === "string" &&
      queryKey[0].startsWith("emr-") &&
      queryKey[1] === clinicId,
  });
